// Radio callout line — squad phase chatter as HUD text (the game's silent
// comms style: radio SFX plays elsewhere, words render here).

const LINE_DURATION = 7;
const FADE_SECONDS = 1.2;

export class RadioHud {
  private readonly el: HTMLElement;
  private life = 0;

  constructor() {
    this.el = document.createElement("div");
    this.el.style.cssText = [
      "position:fixed",
      "left:50%",
      "bottom:16%",
      "transform:translateX(-50%)",
      "font-family:monospace",
      "font-size:13px",
      "letter-spacing:0.14em",
      "color:rgba(190,235,205,0)",
      "text-shadow:0 0 6px rgba(120,220,160,0.35)",
      "pointer-events:none",
      "white-space:nowrap",
      "z-index:200",
    ].join(";");
    document.body.appendChild(this.el);
  }

  // Default speaker is the ground team; the gunship's own transmissions
  // (player commands) pass their callsign explicitly.
  show(text: string, speaker = "ALPHA ACTUAL"): void {
    this.el.textContent = `▸ ${speaker}: ${text}`;
    this.life = LINE_DURATION;
  }

  update(dt: number): void {
    if (this.life <= 0) return;
    this.life -= dt;
    const alpha = Math.min(1, Math.max(0, this.life / FADE_SECONDS));
    this.el.style.color = `rgba(190,235,205,${(0.92 * Math.min(1, alpha)).toFixed(2)})`;
  }

  dispose(): void {
    this.el.remove();
  }
}
